import classNames from 'classnames';
import { useObserver } from 'mobx-react';
import React, { useMemo, useEffect } from 'react';
import { observer } from 'mobx-react';
import { Grid } from '@material-ui/core';

import { useStore } from 'core/store';
import { Card } from 'core/components/card';
import ValueField from 'core/components/value-field';
import { currencyFormatter, dateFormatter } from 'core/helpers/formatters';
import { tooltipHoverTexts } from 'core/helpers/constants';

import useStyles from './equity-breakdown.styles';

function EquityBreakdown() {
  const {
    account: {
      policies: { policy: store }
    }
  } = useStore();
  const classes = useStyles();

  useEffect(() => {
    const { policy } = store;
    if (policy) {
      store.policyEquityStatus.fetchPolicyEquityStatus();
    }
  }, [store]);

  const { policyDays, blendedDailyRate, equityDaysRemaining, paidToDate } = store.policyEquityStatus;

  const [formattedPaidToDate, formattedEquityDaysRemaining] = useMemo(() => {
    //there is only !paidToDate when the end date is in the past
    if (!paidToDate) {
      return ['N/A', 0];
    }
    return [dateFormatter(paidToDate), equityDaysRemaining];
  }, [paidToDate, equityDaysRemaining]);

  return useObserver(() => (
    <Card type="secondary" className={classes.container}>
      <Grid className={classes.connectedCard}>
        <ValueField
          className={classes.valueField}
          label="Blended Daily Rate"
          formatter={currencyFormatter}
          value={blendedDailyRate}
          mode="dark"
        />
        <ValueField className={classes.valueField} label="Policy Days" value={policyDays} mode="dark" />
        <ValueField
          className={classNames(classes.valueField, { [classes.red]: equityDaysRemaining < 0 })}
          label="Equity Days"
          value={formattedEquityDaysRemaining}
          mode="dark"
          showTooltip={{ label: 'More Info', onHoverText: tooltipHoverTexts.equityDays }}
        />
        <ValueField
          className={classes.valueField}
          label="Paid to Date"
          value={formattedPaidToDate}
          mode="dark"
          showTooltip={{ label: 'More Info', onHoverText: tooltipHoverTexts.paidToDate }}
        />
      </Grid>
    </Card>
  ));
}

export default observer(EquityBreakdown);
